export const offerDashboardConstants = {
    GET_OFFER_DASHBOARD_PENDING:   'GET_OFFER_DASHBOARD_PENDING',
    GET_OFFER_DASHBOARD_FULFILLED:   'GET_OFFER_DASHBOARD_FULFILLED',
    GET_OFFER_DASHBOARD_FAILURE:   'GET_OFFER_DASHBOARD_FAILURE',
};
